<template>
  <div>
    <page-header :key="item.id">
      <template #breadcrumbs>
        <router-link :to="{ name: 'Patients', query: { page: this.$route.query.page } }">Регистр ЛРАС</router-link> &raquo;
        <span v-if="item.id">{{ fullName }}</span>
        <span v-else>Новая запись</span>
      </template>
      <h2>Карточка человека с диагнозом РАС</h2>
    </page-header>
    <ul class="nav nav-tabs nav-justified">
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('general')"
          :class="{ 
            active: isActive('general'),
            'marker-new': this.statusesOfChangesParsed.dataWork.active
          }"
          href="#general"
          >Общая информация<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="generalInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('representatives')"
          :class="{ active: isActive('representatives') }"
          href="#representatives"
        >
          Представители<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="representativesInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('addresses')"
          :class="{ 
            active: isActive('addresses'), 
            'marker-new': this.statusesOfChangesParsed.dataAddress.active
          }"
          href="#addresses"
        >
          Адреса<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="addressesInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('info')"
          :class="{ 
            active: isActive('info'), 
          }"
          href="#info"
        >Доп.информация</a>
      </li>
      <li class="nav-item" v-if="canViewDiagnoses || canEditDiagnoses">
        <a
          class="nav-link"
          @click.prevent="setActive('diag')"
          :class="{ active: isActive('diag') }"
          href="#diag"
        >
          Заключение<i
            class="fas fa-info-circle text-danger ml-2"
            v-if="diagInvalid"
          ></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          @click.prevent="setActive('docs')"
          :class="{ active: isActive('docs') }"
          href="#docs"
        >
          Документы</a
        >
      </li>
      <li class="nav-item" v-if="true || canSeeJournal">
        <a
          class="nav-link"
          :class="{ disabled: !item.hasJournal }"
          @click.prevent="goToJournal()"
          href="#journal"
        >
          Дневник</a
        >
      </li>
    </ul>
    <div class="tab-content py-3" id="myTabContent">
      <div
        class="tab-pane fade"
        v-disable-all="isReadonly"
        :class="{ 'active show': isActive('general') }"
        id="general"
      >
        <div style="display: none">
          {{ item.patientDates }}
        </div>
        <div class="general-info">
          <div class="row">
            <div class="form-group col-xl-4 col-md-6 col-xs-6">
              <component-input
                label="Куратор"
                scopeName="general"
                type="select2"
                :select2Options="users"
                :select2Settings="select2Settings"
                v-model="item.curatorId"
              />
            </div>
            <div class="form-group col-xl-2 col-md-6 col-xs-6">
              <component-input
                placeholder="Введите номер"
                label="Регистровый номер"
                v-model="item.registerNumber"
                :maxNumberLength="6"
                scopeName="general"
                :disabled="item.hasRegisterNumber && !canEditRegisterNumber"
              />
            </div>
            <div class="form-group col-xl-2 col-md-6 col-xs-6">
              <label class="control-label">Статус взаимодействия</label>
              <Select2
                :options="statusList"
                v-model="item.statusId"
                class="w100 select2"
              />
            </div>
            <div class="form-group col-xl-4 col-md-6 col-xs-6">
              <label class="control-label">Комментарий</label>
              <input
                type="text"
                class="form-control"
                v-model="item.statusComment"
                placeholder="Комментарий к статусу взаимодействия"
              />
            </div>
            <div class="form-group col-xl-4 col-md-6 col-xs-12">
              <label class="control-label">Важная информация</label>
              <input
                type="text"
                class="form-control"
                v-model="item.info"
                placeholder="Важная информация"
              />
            </div>
            <div class="form-group col-xl-2 col-md-2 col-sm-4">
              <label class="control-label d-none d-md-block">&nbsp;</label>
              <div class="form-check pt-xl-2">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="item.exitFromConcept"
                  id="chExitFromConcept"
                />
                <label for="chExitFromConcept" class="form-check-label control-label"
                  >Вышел из концепции</label
                >
              </div>
            </div>
            <div class="form-group col-xl-6 col-md-4 col-sm-8">
              <label class="control-label d-none d-md-block">&nbsp;</label>
              <component-input
                placeholder="Причина"
                maxLength="250"
                v-model="item.exitFromConceptReason"
                scopeName="general"
              />
            </div>
          </div>
          <div class="row">
            <div v-if="item.isDeleted" class="form-group col-7 text-red">
              <label>Причина исключения из реестра</label>
              <textarea
                class="form-control"
                disabled="disabled"
                v-bind:value="item.deleteReason"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="general-info">
          <h4 class="solid pl-3">Общая информация</h4>
          <div class="row">
            <div class="form-group col-3 required">
              <component-input
                placeholder="Введите фамилию"
                label="Фамилия"
                required
                v-model="item.surname"
                :maxLength="50"
                scopeName="general"
              />
            </div>

            <div class="form-group col-3 required">
              <component-input
                placeholder="Введите имя"
                label="Имя"
                required
                v-model="item.name"
                :maxLength="50"
                scopeName="general"
              />
            </div>

            <div class="form-group col-3">
              <component-input
                placeholder="Введите отчество"
                label="Отчество"
                v-model="item.patronimic"
                :maxLength="50"
                scopeName="general"
              />
            </div>

            <div class="form-group pt-4 col-3">
              <button-component
                v-show="!qrCode"
                class="justify-content-center btn-qr-code"
                @click="showQrCode"
                >Показать QR-код
              </button-component>
              <img
                :src="qrCode"
                v-show="qrCode"
                class="img-qr-code"
                alt="QR-code"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-3 required">
              <label class="control-label">Дата рождения</label>
              <div>
                <date-component
                  :disabled="isReadonly"
                  v-model="item.dateOfBirth"
                  required
                  scopeName="general"
                  :notFuture="true"
                  :maxDate="item.created"
                />
              </div>
            </div>
            <div class="form-group col-3 required">
              <component-input
                label="Пол"
                scopeName="general"
                type="select2"
                required
                :select2Options="gender"
                :select2Settings="select2Settings"
                v-model="item.male"
              />
            </div>

            <div
              class="form-group col-3 required"
              v-disable-all="item.id > 0 && !canEditSnils"
            >
              <component-input
                required
                label="СНИЛС"
                type="snils"
                v-model="item.snils"
                scopeName="general"
                reestr="patient"
              />
            </div>
            <div
              class="form-group pt-4 col-3"
              v-disable-all="item.isLockedForUpdate"
            >
              <button-component
                v-show="!item.isLockedForUpdate && id > 0"
                class="justify-content-center btn-qr-code"
                :disabled="item.isLockedForUpdate"
                @click="updateFromRMIS"
                >Обновить данные из ЕЦП
              </button-component>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-xl-3 col-md-3 col-sm-6 required">
              <component-input label="Гражданство" 
                :select2Options="countryList" 
                v-model="item.countryId" 
                scopeName="general"
                type="select2" 
                :select2Settings="select2settings"
                v-on:select2OnSelect="countryChanged()" 
                placeholder="Не указано"
                required />     
            </div>
          </div>
        </div>
        <div class="general-info">
          <h4 class="solid pl-3">Свидетельство о рождении</h4>
          <div class="row">
            <div class="form-group col-xl-1 col-md-1 col-sm-4">
              <component-input
                label="Серия"
                maxLength="10"
                v-model="item.birthCertSerie"
                scopeName="general"
              />
            </div>
            <div class="form-group col-xl-2 col-md-2 col-sm-4">
              <component-input
                v-if="item.countryId == countryRussiaId || !item.countryId"
                label="Номер"
                type="birthCertNum"
                v-model="item.birthCertNum"
                scopeName="general"
              />
              <component-input
                v-else
                label="Номер"
                type="birthCertNumForeign"
                v-model="item.birthCertNum"
                scopeName="general"
                maxLength="20"
              />
            </div>
            <div class="form-group col-xl-2 col-md-3 col-sm-4">
              <label class="control-label">Дата выдачи</label>
              <div>
                <date-component
                  :disabled="isReadonly"
                  v-model="item.birthCertDt"
                />
              </div>
            </div>
            <div class="form-group col-xl-7 col-md-6 col-sm-12">
              <component-input
                label="Кем выдано"
                maxLength="250"
                v-model="item.birthCertWhere"
                scopeName="general"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-xl-2 col-md-3 col-sm-4">
              <div class="form-check mt-2">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="item.birthDublicate"
                  id="chDublicate"
                />
                <label for="chDublicate" class="form-check-label control-label"
                  >Повторное</label
                >
              </div>
            </div>
            <div class="form-group col-xl-10 col-md-9 col-sm-8">
              <component-input
                placeholder="Доп. информация"
                maxLength="250"
                v-model="item.birthDublicateInfo"
                scopeName="general"
              />
            </div>
          </div>
        </div>
        <div class="general-info">
          <h4 class="solid pl-3">Паспортные данные</h4>
          <div>
            <div class="row">
              <div class="form-group col-1">
                <component-input
                  v-if="item.countryId == countryRussiaId || !item.countryId"
                  label="Серия"
                  type="passportSerie"
                  v-model="item.passportSerie"
                  scopeName="general"
                />
                <component-input
                  v-else
                  label="Серия"
                  type="passportSerieForeign"
                  v-model="item.passportSerie"
                  scopeName="general"
                  maxLength="20"
                />
              </div>
              <div class="form-group col-2">
                <component-input
                  v-if="item.countryId == countryRussiaId || !item.countryId"
                  label="Номер"
                  type="passportNum"
                  v-model="item.passportNum"
                  scopeName="general"
                />
                <component-input
                  v-else
                  label="Номер"
                  type="passportNumForeign"
                  v-model="item.passportNum"
                  scopeName="general"
                  maxLength="20"
                />
              </div>
              <div class="form-group col-9">
                <component-input
                  label="Место выдачи"
                  v-model="item.passportWhere"
                  placeholder="Введите место выдачи"
                  scopeName="general"
                />
              </div>
            </div>
            <div class="row">
              <div class="form-group col-3">
                <label class="control-label">Дата выдачи</label>
                <div>
                  <date-component
                    :disabled="isReadonly"
                    v-model="item.passportDt"
                    scopeName="general"
                  />
                </div>
              </div>
              <div class="form-group col-3">
                <component-input
                  label="Код подразделения"
                  type="passportDep"
                  v-model="item.passportDep"
                  scopeName="general"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="general-info">
          <h4 class="solid pl-3">Медицинский полис</h4>
          <div class="row">
            <div class="form-group col-4">
              <label class="control-label">Тип полиса</label>
              <Select2
                placeholder="Не указано"
                :options="insuranceTypeList"
                v-model="item.insuranceTypeId"
                class="w100 select2"
              />
            </div>
            <div class="form-group col-3" v-if="item.insuranceTypeId == 4">
              <component-input
                label="Серия (для старого образца)"
                placeholder="XXXXX"
                v-model="item.insuranceSerie"
              />
              <div class="invalid-msg" v-if="v$.item.insuranceSerie.$error">
                <template
                  v-if="
                    v$.item.insuranceSerie.numberFixLengthValidator.$invalid
                  "
                  >Длина поля
                  {{
                    v$.item.insuranceSerie.numberFixLengthValidator.$params
                      .value
                  }}
                  символов, только цифры
                </template>
                <template v-else
                  >Поле обязательно для заполнения для полиса старого
                  образца</template
                >
              </div>
            </div>
            <div
              class="form-group col-5 required"
              v-if="item.insuranceTypeId > 0"
            >
              <component-input
                label="Номер"
                placeholder="Введите номер полиса"
                v-model="item.insuranceNum"
              />
              <div class="invalid-msg" v-if="v$.item.insuranceNum.$error">
                <template
                  v-if="v$.item.insuranceNum.insNumLengthValidator.$invalid"
                  >Длина поля 16 для единого образца, 9 для временного и 6 для
                  старого, только цифры
                </template>
                <!-- <template v-else>Поле обязательно для заполнения</template> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-3">
              <component-input
                label="Полис ДМС"
                placeholder="Введите номер полиса"
                v-model="item.dmsNum"
              />
            </div>
          </div>
        </div>
        <div class="general-info">
          <h4
            :class="{'marker-new': this.statusesOfChangesParsed.dataWork.active}" 
            class="solid pl-3"
          >
            Трудовая деятельность
          </h4>
          <div class="row">
            <div class="form-group col-xl-3 col-md-4 col-sm-6">
              <div class="form-check mt-2">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="item.isSearchJob"
                  id="chSearchJob"
                  :disabled="isReadonly || !canEditSearchJob"
                />
                <label for="chSearchJob" class="form-check-label control-label"
                  >Требуется инклюзивное трудоустройство</label
                >
              </div>
            </div>
            <div class="form-group col-xl-9 col-md-8 col-sm-6">
              <component-input
                placeholder="Комментарий"
                maxLength="250"
                v-model="item.searchJobComment"
                scopeName="general"
                :disabled="isReadonly || !canEditSearchJob"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <component-input
                label="Место работы"
                v-model="item.workPlace"
                :maxLength="500"
                scopeName="general"
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <component-input
                label="Основная профессия (специальность)"
                v-model="item.job"
                :maxLength="500"
                scopeName="general"
              />
            </div>
            <div class="form-group col-2">
              <component-input
                label="Стаж"
                v-model="item.seniority"
                :maxLength="500"
                scopeName="general"
              />
            </div>
            <div class="form-group col-4">
              <component-input
                label="Квалификация"
                v-model="item.qualification"
                :maxLength="500"
                scopeName="general"
              />
            </div>
          </div>
        </div>

        <div class="general-info mt-32 mb-5">
          <div class="form-check my-3">
            <input
              type="checkbox"
              class="form-check-input"
              v-model="item.agree"
              id="chAgree"
            />
            <label for="chAgree" class="form-check-label control-label"
              >Согласие на внесение в Регистр ЛРАС</label
            >
          </div>
          <div class="form-check my-3 required">
            <component-input
              label="Согласие на обработку персональных данных"
              v-model="item.agreePersonalData"
              id="chAgreePersonalData"
              type="checkbox"
              scopeName="general"
              :required="true"
            />
          </div>
          <div class="form-check my-3">
            <component-input
              label="Запись активна"
              v-model="item.isActive"
              id="chActive"
              type="checkbox"
              scopeName="general"
            />
          </div>
          <div class="form-check my-3">
            <component-input
              label="Запись заблокирована для обновления"
              v-model="item.isLockedForUpdate"
              id="chLocked"
              type="checkbox"
              scopeName="general"
            />
          </div>
          <div class="my-3" v-if="item.id > 0">
            <span
              >Дата внесения в Регистр:
              <b>{{ $momentFormat(item.created, "DD.MM.YYYY") }}</b></span
            >
          </div>
          <div class="my-3" v-if="item.id > 0">
            <span
              >Организация, добавившая в Регистр:
              <b>{{ item.createdByOrgName }}</b></span
            >
          </div>
        </div>

        <div class="card-footer" v-if="!isReadonly">
          <a
            class="card-footer__btn card-footer__btn--blue btn"
            @click.prevent="setActive('representatives')"
            :class="{ active: isActive('representatives') }"
            href="#representatives"
            >Далee</a
          >
          <div class="float-right">
            <button
              type="button"
              class="btn card-footer__btn"
              v-on:click="close"
            >
              Отмена
            </button>
            <button class="btn card-footer__btn--blue mx-2" v-on:click="save">
              Сохранить
            </button>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        v-disable-all="isReadonly"
        :class="{ 'active show': isActive('representatives') }"
        id="representatives"
      >
        <div
          v-if="!item.patientRepresentatives.length >= 1"
          class="form-group--border d-flex align-items-center"
        >
          <button-component
            v-if="!isReadonly"
            class="justify-content-center"
            @click="addRepres"
            >Добавить представителя
          </button-component>
          <div class="invalid-msg ml-2" v-if="v$.item.patientRepresentatives.$error" style="font-size:1rem;">Поле обязательно для заполнения</div>
        </div>
        <div
          v-for="(repres, rIdx) in item.patientRepresentatives"
          :key="repres.representativeId"
          class="form-group--border"
        >
          <div
            v-if="item.patientRepresentatives.length"
            class="general-info pb-0 border-0"
          >
            <div class="form-group d-flex flex-wrap align-items-center solid">
              <h4 class="mr-5 ml-3">
                {{ getTitle(repres) }}
              </h4>
              <button-component
                v-if="!isReadonly"
                class="justify-content-center btn-sm card-footer__btn white my-2"
                @click="removeRepres(repres.representativeId)"
                >Удалить
              </button-component>
              <button-component
                v-if="
                  !isReadonly &&
                  !repres.editAllowed &&
                  repres.representativeId > 0
                "
                class="justify-content-center btn-sm card-footer__btn mx-4 white my-2"
                @click="allowEditRepres(repres)"
                >Редактировать персональные данные
              </button-component>
            </div>
            <div v-if="repres.representativeId <= 0">
              <div class="row d-flex align-items-end">
                <div class="form-group col-3">
                  <component-input
                    label="СНИЛС"
                    type="snils"
                    v-model="repres.representative.snilsForSearch"
                    useDefaultValidation="false"
                    scopeName="general"
                  />
                </div>
                <div class="form-group col-3">
                  <button-component
                    v-if="!isReadonly"
                    class="justify-content-center btn-sm"
                    @click="
                      fillBySnils(rIdx, repres.representative.snilsForSearch)
                    "
                    >Заполнить по СНИЛС
                  </button-component>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Разрешить доступ?</label>
              <div class="row">
                <div class="col-1">
                  <div class="form-check">
                    <input
                      type="radio"
                      class="form-check-input"
                      v-model="repres.hasAccess"
                      v-bind:value="true"
                      id="L1"
                    />
                    <label class="form-check-label" for="L1">Да</label>
                  </div>
                </div>
                <div class="col-sm-1">
                  <div class="form-check">
                    <input
                      type="radio"
                      class="form-check-input"
                      v-model="repres.hasAccess"
                      v-bind:value="false"
                      id="R0"
                    />
                    <label class="form-check-label" for="R0">Нет</label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="form-group col-3 required">
                  <component-input
                    label="Фамилия"
                    required
                    placeholder="Фамилия"
                    v-model="repres.representative.surname"
                    :disabled="disabled(repres)"
                    scopeName="representatives"
                  />
                </div>
                <div class="form-group col-3 required">
                  <component-input
                    label="Имя"
                    required
                    placeholder="Имя"
                    v-model="repres.representative.name"
                    :disabled="disabled(repres)"
                    scopeName="representatives"
                  />
                </div>
                <div class="form-group col-3">
                  <component-input
                    label="Отчество"
                    placeholder="Отчество"
                    v-model="repres.representative.patronimic"
                    :disabled="disabled(repres)"
                    scopeName="representatives"
                  />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-3 required">
                  <component-input
                    label="Пол"
                    scopeName="representatives"
                    type="select2"
                    :required="true"
                    :select2Options="gender"
                    :select2Settings="select2Settings"
                    v-model="repres.representative.male"
                    :disabled="disabled(repres)"
                  />
                </div>
                <div class="form-group col-3 required">
                  <component-input
                    label="Степень родства"
                    scopeName="representatives"
                    type="select2"
                    :required="true"
                    :select2Options="relationTypeList"
                    :select2Settings="select2Settings"
                    v-model="repres.relationTypeId"
                    :disabled="disabled(repres)"
                  />
                </div>
                <div
                  class="form-group col-3 required"
                  v-disable-all="repres.representativeId > 0 && !canEditSnils"
                >
                  <component-input
                    label="СНИЛС"
                    type="snils"
                    reestr="repres"
                    required
                    v-model="repres.representative.snils"
                    scopeName="representatives"
                  />
                  <div
                    class="invalid-msg"
                    v-if="hasDuplicateSnils(rIdx)"
                  >
                    СНИЛС должен быть уникальным
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-3" :class="{ 'required' : isBirthDateObligatory(repres) }">
                  <label class="control-label">Дата рождения</label>
                  <div>
                    <date-component
                      :disabled="disabled(repres)"
                      v-model="repres.representative.dateOfBirth"
                      :required="isBirthDateObligatory(repres)"
                      :minAge="18"
                      scopeName="representatives"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="general-info border-0 mt-32">
              <h4>Паспортные данные</h4>
              <div>
                <div class="row">
                  <div class="form-group col-1 required">
                    <component-input
                      label="Серия"
                      type="passportSerie"
                      required
                      v-model="repres.representative.passportSerie"
                      :disabled="disabled(repres)"
                      scopeName="representatives"
                    />
                  </div>
                  <div class="form-group col-2 required">
                    <component-input
                      label="Номер"
                      type="passportNum"
                      required
                      v-model="repres.representative.passportNum"
                      :disabled="disabled(repres)"
                      scopeName="representatives"
                    />
                  </div>
                  <div class="form-group col-9 required">
                    <component-input
                      label="Место выдачи"
                      v-model="repres.representative.passportWhere"
                      required
                      placeholder="Введите место выдачи"
                      :disabled="disabled(repres)"
                      scopeName="representatives"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-3 required">
                    <label class="control-label">Дата выдачи</label>
                    <div>
                      <date-component
                        v-model="repres.representative.passportDt"
                        scopeName="representatives"
                        :disabled="disabled(repres)"
                        required
                      />
                    </div>
                  </div>
                  <div class="form-group col-3 required">
                    <component-input
                      label="Код подразделения"
                      type="passportDep"
                      required
                      v-model="repres.representative.passportDep"
                      :disabled="disabled(repres)"
                      useDefaultValidation="false"
                      scopeName="representatives"
                    />
                  </div>
                </div>
              </div>
            </div>
            <h4>Контакты</h4>
            <div class="general-info__wrapper row">
              <div class="form-group col-2 required">
                <component-input
                  type="phone"
                  label="Контактный телефон"
                  v-model="repres.representative.phone"
                  :disabled="disabled(repres)"
                  scopeName="representatives"
                  required
                />
              </div>

              <div class="form-group col-3">
                <component-input
                  placeholder="E-mail"
                  label="E-mail"
                  v-model="repres.representative.email"
                  :disabled="disabled(repres)"
                  scopeName="representatives"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">Дополнительные сведения</label>
              <div>
                <textarea
                  class="form-control form-control--textarea"
                  v-model="repres.additional"
                  placeholder="Введите текст"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="mb-5">
          <button-component
            v-if="!isReadonly && item.patientRepresentatives.length"
            class="justify-content-center"
            @click="addRepres"
            >Добавить еще представителя
          </button-component>
        </div>

        <div class="card-footer pt-4" v-if="!isReadonly">
          <a
            class="btn card-footer__btn mx-2 btn-default"
            @click.prevent="setActive('general')"
            href="#general"
            >Назад</a
          >
          <a
            class="card-footer__btn card-footer__btn--blue mx-2 btn"
            @click.prevent="setActive('addresses')"
            href="#addresses"
            >Далee</a
          >
          <div class="float-right">
            <button
              type="button"
              class="btn btn-secondary mx-2 card-footer__btn"
              v-on:click="close"
            >
              Отмена
            </button>
            <button class="btn card-footer__btn--blue mx-2" v-on:click="save">
              Сохранить
            </button>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        v-disable-all="isReadonly"
        :class="{ 'active show': isActive('addresses') }"
        id="addresses"
      >
        <div class="personal-address" v-for="addr in item.patientAddresses">
          <person-address
            :model-value="addr"
            :readonly="isReadonly"
            :nn="nn"
            @update:modelValue="addr = $event"
            @copyaddress="copyAddress"
            :dataAddresMarker="this.statusesOfChangesParsed.dataAddress.active"
          ></person-address>
        </div>
        <div class="card-footer pt-4" v-if="!isReadonly">
          <a
            class="btn card-footer__btn mx-2 btn-default"
            @click.prevent="setActive('representatives')"
            href="#representatives"
            >Назад</a
          >
          <a
            class="card-footer__btn card-footer__btn--blue mx-2 btn"
            @click.prevent="setActive('info')"
            href="#info"
            >Далee</a
          >
          <div class="float-right">
            <button
              type="button"
              class="btn btn-secondary mx-2 card-footer__btn"
              v-on:click="close"
            >
              Отмена
            </button>
            <button class="btn card-footer__btn--blue mx-2" v-on:click="save">
              Сохранить
            </button>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        v-disable-all="isReadonly"
        :class="{ 'active show': isActive('info') }"
        id="info"
      >
        <div>
          <h4 class="solid pl-3">Дополнительная информация</h4>
        </div>
        <div>
          <div class="row">
            <div class="col-12">
                <div class="mt-2">

                  <template v-if="isReadonly"><!-- карточка открыта на просмотр -->
                    <div class="col col-md-12">
                      <label class="control-label">Комментарии от учреждений здравоохранения</label>
                      <template v-if="dopInfo.canEdit">
                        <div class="btn" v-on:click="editComment">
                          <i class="fa fa-pen" title="Редактировать"></i>
                        </div>
                      </template>
                      <div>
                        <template v-if="item.comment">
                          <div v-html="item.comment.replace(/\n/g, '<br>')"></div>
                          <!-- {{ item.comment }} -->
                        </template>
                        <template v-else>
                          не заданы
                        </template>
                      </div>
                    </div>
                  </template>
                  <template v-else><!-- карточка открыта на редактирование -->
                    <div class="col col-md-12">
                      <component-input
                        label="Комментарии от учреждений здравоохранения"
                        type="textarea"
                        v-model="item.comment"
                        mod-class="textareaBig"
                      />
                    </div>
                  </template>
                </div> 
            </div>
          </div>       
          <div class="row" v-if="item.isDeletedPermanently">
            <div class="col-12">
                <div class="mt-2">
                  <div class="col col-md-12">
                    <label class="control-label">Причина удаления</label>
                    <div class="text-red">
                      <template v-if="item.deleteReasonPermanently">
                        <div v-html="item.deleteReasonPermanently.replace(/\n/g, '<br>')"></div>
                      </template>
                      <template v-else>
                        не задана
                      </template>
                    </div>
                  </div>
                </div> 
            </div>
          </div>   
        </div>

        <div class="card-footer pt-4" v-if="!isReadonly">
          <a
            class="btn card-footer__btn mx-2 btn-default"
            @click.prevent="setActive('addresses')"
            href="#addresses"
            >Назад</a
          >
          <a
            class="card-footer__btn card-footer__btn--blue mx-2 btn"
            @click.prevent="setActive('diag')"
            href="#diag"
            >Далee</a
          >
          <div class="float-right">
            <button
              type="button"
              class="btn btn-secondary mx-2 card-footer__btn"
              v-on:click="close"
            >
              Отмена
            </button>
            <button class="btn card-footer__btn--blue mx-2" v-on:click="save">
              Сохранить
            </button>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        v-if="canViewDiagnoses || canEditDiagnoses"
        v-disable-all="isReadonly || !canEditDiagnoses"
        :class="{ 'active show': isActive('diag') }"
        id="diag"
      >
        <Loader v-if="importInProgress" />
        <div v-if="!importInProgress">
          <h4 class="solid pl-3">Диагнозы, впервые установленные</h4>
          <template v-if="firstTimeDiags.length">
            <table class="table-custom">
              <thead>
                <tr>
                  <th>Диагноз</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="diag in firstTimeDiags" :key="diag.id">
                  <td>{{ diag.diag.externalCode }}. {{ diag.diag.name }}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <EmptyListMessage class="text-center p-2" />
          </template>
        </div>
        <div v-if="!importInProgress">
          <h4 class="solid pl-3 mt-2">Уточненные диагнозы</h4>
          <template v-if="updatedDiags.length">
            <table class="table-custom">
              <thead>
                <tr>
                  <th>Диагноз</th>
                  <th>Мед. организация</th>
                  <th>Наименование профиля отделения</th>
                  <th>Дата установления диагноза</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="diag in updatedDiags" :key="diag.id">
                  <td>{{ diag.diag.externalCode }}. {{ diag.diag.name }}</td>
                  <td>{{ diag.lpu.name }}</td>
                  <td>{{ diag.lpuSectionProfileName }}</td>
                  <td>
                    {{
                      diag.dateOfDiag
                        ? $momentFormat(diag.dateOfDiag, "DD.MM.YYYY")
                        : ""
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <EmptyListMessage class="text-center p-2" />
          </template>
        </div>
        <div class="row">
          <div class="form-group col-8">
            <component-input
              label="Инвалидность"
              v-model="item.invalidity"
              :maxLength="500"
              :disabled="importInProgress"
            />
          </div>
          <div class="form-group col-4">
            <label class="control-label">Дата установления (пересмотра)</label>
            <div>
              <date-component
                :disabled="isReadonly || importInProgress"
                v-model="item.dateInvalidity"
              />
            </div>
          </div>
        </div>
        <div class="card-footer pt-4" v-if="!isReadonly">
          <a
            class="btn card-footer__btn mx-2 btn-default"
            @click.prevent="setActive('info')"
            href="#info"
            >Назад</a
          >
          <a
            class="card-footer__btn card-footer__btn--blue mx-2 btn"
            @click.prevent="setActive('docs')"
            href="#docs"
            >Далee</a
          >
          <div class="float-right">
            <button
              class="btn card-footer__btn--blue mx-2"
              v-on:click="importDiagnosis"
              :disabled="importInProgress"
            >
              Обновить данные из ЕЦП
            </button>
            <button
              type="button"
              class="btn btn-secondary mx-2 card-footer__btn"
              v-on:click="close"
              :disabled="importInProgress"
            >
              Отмена
            </button>
            <button
              class="btn card-footer__btn--blue mx-2"
              v-on:click="save"
              :disabled="importInProgress"
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
      <div
        class="tab-pane fade"
        v-disable-all="isReadonly"
        :class="{ 'active show': isActive('docs') }"
        id="docs"
      >
        <div class="form-group--files">
          <div class="d-flex flex-column">
            <div class="d-flex flex-column">
              <button-component
                class="btn btn-primary my-2"
                title="Прикрепить документ"
                @click="addFile"
                v-if="!isReadonly"
                >Прикрепить документ
              </button-component>
              <div v-if="item.patientFiles.length === 0">
                Нет прикрепленных файлов
              </div>
              <div v-for="(file, index) in item.patientFiles" :key="index">
                <div class="d-flex align-items-center mt-3">
                  <div class="flex-column">
                    <FileUpload
                      @deleteFile="removeFile(index)"
                      :entity="file"
                      prop-name="file"
                      :entity-index="index"
                      @uploaded="fileUploaded"
                      :readonly="isReadonly"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer pt-4" v-if="!isReadonly">
          <a
            class="btn card-footer__btn mx-2 btn-default"
            @click.prevent="setActive('diag')"
            href="#diag"
            >Назад</a
          >
          <div class="float-right">
            <button
              type="button"
              class="btn btn-secondary mx-2 card-footer__btn"
              v-on:click="close"
            >
              Отмена
            </button>
            <button class="btn card-footer__btn--blue mx-2" v-on:click="save">
              Сохранить
            </button>
          </div>
        </div>
      </div>
      <div class="card-footer pt-4" v-if="isReadonly">
        <div class="float-right">
          <button
            type="button"
            class="btn btn-secondary card-footer__btn"
            v-on:click="close"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
    <modal-component
          v-if="dopInfo.showCommentModal"
          title="Дополнительная информация"
          size-class=""
          @close="dopInfo.showCommentModal = false"
        >
      <div>
            <div class="row my-3">

              <div class="col col-md-12">
                <component-input
                  label="Комментарии от учреждений здравоохранения"
                  type="textarea"
                  v-model="dopInfo.comment"
                  modClass="textareaBig"
                />
              </div>

            </div>

            <div>
              <div class="float-right">
                <button class="btn  btn-primary mx-2" v-on:click="updateComment">Сохранить</button>
                <button type="button" class="btn btn-default" v-on:click="dopInfo.showCommentModal = false">Закрыть</button>
              </div>
             </div>

      </div>
    </modal-component>
  </div>
</template>
<script>
import API from "../api/ras";
import UserAPI from "@/modules/admin/api/users";
import Constants from "../../../common/constants";
import { helpers, numeric, required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import DateComponent from "@/common/components/DateComponent";
import Utils from "../../../common/utils";
import ComponentInput from "@/common/components/ComponentInput";
import PageHeader from "@/common/components/page/PageHeader";
import disableAll from "@/common/directives/disable-all";
import FileUpload from "@/common/components/FileUpload";
import ButtonComponent from "@/common/ui/ButtonComponent";
import PersonAddress from "../components/PersonAddress";
import security from "../../../common/mixins/security";
import Loader from "@/common/ui/Loader";
import ModalComponent from "@/common/ui/ModalComponent";
import moment from 'moment'

//const selectValidator = (value) => value > 0;

const numberFixLengthValidator = (param, insuranceTypeId) =>
  helpers.withParams(
    { type: "numberFixLengthValidator", value: param },
    (value) => {
      if (insuranceTypeId != 4) return true;
      if (!value || value.length === 0) return true;
      var re = new RegExp("^[0-9]{" + param + "}$");
      return {
        $valid: re.test(value),
        extraParams: { scope: "general" },
      };
    }
  );

const insNumLengthValidator = (param) =>
  helpers.withParams(
    { type: "insNumLengthValidator", value: param },
    (value) => {
      if (!(param > 0)) return true;

      var len = 16;
      if (param == 3) len = 9;
      else if (param == 4) len = 6;
      var res = value && value.length === len;
      if (res) {
        var re = new RegExp("^[0-9]{" + len + "}$");
        res = res && re.test(value);
      }
      return {
        $valid: res,
        extraParams: { scope: "general" },
      };
    }
  );

export default {
  name: "PatientCard",
  components: {
    PersonAddress,
    ButtonComponent,
    FileUpload,
    PageHeader,
    ComponentInput,
    DateComponent,
    Loader,
    ModalComponent
  },
  directives: {
    "disable-all": disableAll,
  },
  mixins: [security],
  props: {
    patient: {
      type: Number,
      required: false,
      default: null,
    },
  },
  created() {
    this.checkPermissions([Constants.PatientEdit, Constants.PatientView]);
    this.checkPermission(Constants.DiagnosesView).then((response) => {
      this.canViewDiagnoses = response.data;
      this.checkPermission(Constants.DiagnosesEdit).then((response) => {
        this.canEditDiagnoses = response.data;
        if (!this.canEditDiagnoses && this.isEdit) {
          this.canViewDiagnoses = false;
        }
      });
    });
    if (this.isEdit) {
      this.checkPermission(Constants.EditSnils).then((response) => {
        this.canEditSnils = response.data;
      });
      this.checkPermission(Constants.PatientChangeRegisterNumber).then((response) => {
        this.canEditRegisterNumber = response.data;
      });
    }
    this.checkPermission(Constants.PatientChangeSearchJob).then((response) => {
      this.canEditSearchJob = response.data;
    });
    this.checkPermission(Constants.PatientCommentEdit).then((response) => {
        this.dopInfo.canEdit = response.data;
      });

    this.loadPage();

    Utils.loadSelectOptions("insuranceType", this.insuranceTypeList);
    Utils.loadSelectOptions("relationType", this.relationTypeList);
    Utils.loadSelectOptions("patientStatusList", this.statusList);
    Utils.loadSelectOptions("countries", this.countryList);
  },
  data() {
    return {
      nn: 0,
      id: this.$route.params.id,
      view: this.$route.params.view,
      tmpPatientId: this.$route.query.tmpPatientId,
      isReadonly: this.$route.params.action === "view",
      isEdit: this.$route.params.action === "edit",
      statusOfChangeId: this.$route.params?.statusOfChangeId,
      statusOfChangeResponse: null,
      statusesOfChangesParsed: {
        imarStatus: {
          active: null,
          itemId: null,
        },
        serviceEnd: {
          active: null,
          itemId: null,
        },
        imarEnd: {
          active: null,
          itemId: null,
        },
        serviceNotBecome: {
          active: null,
          itemId: null,
        },
        dataAddress: {
          active: null,
          itemId: null,
        },
        dataSchool: {
          active: null,
          itemId: null,
        },
        dataSchoolProf: {
          active: null,
          itemId: null,
        },
        dataWork: {
          active: null,
          itemId: null,
        },
        organization: {
          active: null,
          itemId: null,
        },
      },
      gender: [
        { id: true, text: "Мужской", value: 1 },
        { id: false, text: "Женский", value: 0 },
      ],
      item: {
        id: 0,
        male: true,
        isSearchJob: false,
        searchJobComment: "",
        patientRepresentatives: [],
        patientFiles: [],
        access: "",
        statusId: 1,
        insuranceTypeId: 0,
        countryId: Constants.countryRussiaId,
        created: moment().format("YYYY-MM-DD"),
        hasRegisterNumber: false,
      },
      activeItem: "general",
      insuranceTypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      countryRussiaId: Constants.countryRussiaId,
      countryList: [],
      relationTypeList: [],
      nextRepresId: 0,
      qrCode: "",
      users: [],
      statusList: [],
      canViewDiagnoses: true,
      canEditDiagnoses: true,
      canEditSnils: true,
      canEditSearchJob: false,
      canEditRegisterNumber: false,
      generalInvalid: false,
      addressesInvalid: false,
      diagInvalid: false,
      representativesInvalid: false,
      select2Settings: Constants.select2Settings,
      firstTimeDiags: [],
      updatedDiags: [],
      importInProgress: false,

      dopInfo: {
        showCommentModal: false,
        read: true,
        canEdit: false,
        comment: ""
      },
      canSeeJournal: true
    };
  },
  methods: {
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
    goToJournal() {
      this.$router.push({
        name: "journalCard",
        params: { action: this.$route.params.action, id: this.item.id },
        query: { page: this.$route.query.page, page2: this.$route.query.page2 }
      });
    },
    addRepres() {
      var patientRepres = {
        patientId: this.item.id,
        representative: { 
          male: true,
          dateObligatory: true
        },
        representativeId: this.nextRepresId,
        hasAccess: false,
        gender: this.gender,
      };
      this.nextRepresId -= 1;
      this.item.patientRepresentatives.push(patientRepres);
      console.log(this.item.patientRepresentatives);
    },
    removeRepres(represId) {
      const idx = this.item.patientRepresentatives.findIndex(
        (p) => p.representativeId == represId
      );
      this.item.patientRepresentatives.splice(idx, 1);
    },
    allowEditRepres(repres) {
      repres.editAllowed = true;
    },
    fillBySnils(index, snils) {
      API.findRepresBySnils(snils).then((response) => {
        if (response.data && response.data.id > 0) {
          this.item.patientRepresentatives[index].representative =
            response.data;
          this.item.patientRepresentatives[index].representativeId =
            response.data.id;
        } else
          Constants.alert.fire(
            "Поиск представителя",
            "Представитель с таким СНИЛС в системе не найден, заполните, пожалуйста, все необходимые данные на карточке вручную",
            "warning"
          );
      });
    },
    disabled(repres) {
      return (
        repres.representativeId > 0 && !repres.editAllowed && !this.canEditSnils
      );
    },
    loadStatusIds(){
      API.patientChangeGet(this.id).then(response => {
        this.statusOfChangeResponse = response.data;
        if(this.statusOfChangeResponse.length > 0){
          for (let i = 0; i < this.statusOfChangeResponse.length; i++) {
            let interationStatusOfChange = this.statusOfChangeResponse[i].patientChangeId,
              interationStatusItemId = this.statusOfChangeResponse[i].itemId;
            switch (interationStatusOfChange) {
              case 1:
                this.statusesOfChangesParsed.imarStatus = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 2:
                this.statusesOfChangesParsed.serviceEnd = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 3:
                this.statusesOfChangesParsed.imarEnd = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 4:
                this.statusesOfChangesParsed.serviceNotBecome = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 5:
                this.statusesOfChangesParsed.dataAddress = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 6:
                this.statusesOfChangesParsed.dataSchool = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 7:
                this.statusesOfChangesParsed.dataSchoolProf = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 8:
                this.statusesOfChangesParsed.dataWork = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              case 9:
                this.statusesOfChangesParsed.organization = {
                  active: true,
                  itemId: interationStatusItemId
                };
                break;
              default:
                break;
            }
          }
        }
        if(this.statusesOfChangesParsed.dataAddress.active == true){
          this.setActive('addresses');
        }
        else if(this.statusesOfChangesParsed.dataWork.active == true){
          this.setActive('general');
        }
      });
    },
    loadPage() {
      if (this.patient || this.id > 0) {
        API.find(this.patient || this.id).then((response) => {
          this.item = response.data;
          //console.log(this.item);
          if (this.isEdit && this.item.isDeleted) {
            this.isEdit = false;
            this.isReadonly = true;
          }
          this.item.hasRegisterNumber = Boolean(this.item.registerNumber?.trim());

          //высчитываем обязательность заполнение ДР
          this.item.patientRepresentatives?.forEach(item => {
            item.representative.dateObligatory =
              item.representative?.dateOfBirth != null;
          });

          if (this.item.insuranceTypeId == null) this.item.insuranceTypeId = 0;

          if (!this.isReadonly && this.item.patientFiles.length === 0) {
            this.addFile();
          }
          this.ensureAddresses();
          this.loadDiags();
        });
      } else {
        if (this.tmpPatientId > 0) {
          API.findTmpPatient(this.tmpPatientId).then((response) => {
            if (response.data) {
              //this.item.id = response.data.id;
              this.item.surname = response.data.surname;
              this.item.name = response.data.name;
              this.item.patronimic = response.data.patronimic;
              this.item.dateOfBirth = response.data.dateOfBirth;
              this.item.tmpPatientId = this.tmpPatientId;

              //console.log(response.data);
              if (
                response.data.tmpRepresentatives &&
                response.data.tmpRepresentatives.length > 0
              ) {
                //console.log(response.data.tmpRepresentatives[0]);
                var patientRepres = {
                  patientId: this.item.id,
                  representative: {
                    male: true,
                    name: response.data.tmpRepresentatives[0].name,
                    patronimic: response.data.tmpRepresentatives[0].patronimic,
                    surname: response.data.tmpRepresentatives[0].surname,
                    phone: response.data.tmpRepresentatives[0].phone,
                    dateObligatory: true
                  },
                  representativeId: this.nextRepresId,
                  hasAccess: false,
                  gender: this.gender,
                  relationTypeId:
                    response.data.tmpRepresentatives[0].relationTypeId,
                };
                this.nextRepresId -= 1;
                this.item.patientRepresentatives.push(patientRepres);
              }
            }
            this.ensureAddresses();
            this.loadDiags();
          });
        } else {
          this.ensureAddresses();
        }
      }
      this.loadDictionaries();
      this.loadStatusIds();
    },
    loadDictionaries() {
      UserAPI.search({ pageNumber: 1, pageSize: -1 }).then((response) => {
        this.users = response.data.items.map((x) => ({
          id: x.id,
          text: `${x.fullName} (${x.userName})`,
        }));
      });
    },
    // ensureAddresses() {
    //   if (!this.item.patientAddresses || !this.item.patientAddresses.length) {
    //     API.loadAddressTypes().then((response) => {
    //       this.item.patientAddresses = [];
    //       response.data.forEach((item) => {
    //         this.item.patientAddresses.push({
    //           id: 0,
    //           addressTypeId: item.id,
    //           addressType: {
    //             id: item.id,
    //             name: item.name,
    //             title: item.title,
    //           },
    //           stateId: "1",
    //           regionId: "52",
    //           districtId: "0",
    //         });
    //       });
    //     });
    //   } else {
    //     this.item.patientAddresses.forEach((el) => {
    //       if (el.districtId === null) el.districtId = "0";
    //       if (el.regionId === null) el.regionId = "52";
    //       if (el.stateId === null) el.stateId = "1";
    //     });
    //   }
    // },
    ensureAddresses() {
      API.loadAddressTypes().then((response) => {
        const types = response.data;
        if (!this.item.patientAddresses) {
          this.item.patientAddresses = [];
        }

        // Приводим существующие адреса к нужным дефолтам
        this.item.patientAddresses.forEach((el) => {
          if (el.districtId == null) el.districtId = "0";
          if (el.regionId == null) el.regionId = "52";
          if (el.stateId == null) el.stateId = "1";
        });

        // Новый массив адресов — в правильном порядке
        const orderedAddresses = [];

        types.forEach((type) => {
          // Ищем существующий адрес с этим типом
          const existing = this.item.patientAddresses.find(
            (a) => a.addressTypeId === type.id
          );

          if (existing) {
            // Добавляем существующий (сохраняем объект)
            orderedAddresses.push(existing);
          } else {
            // Добавляем новый, если отсутствует
            orderedAddresses.push({
              id: 0,
              addressTypeId: type.id,
              addressType: {
                id: type.id,
                name: type.name,
                title: type.title,
              },
              stateId: "1",
              regionId: "52",
              districtId: "0",
            });
          }
        });

        // Заменяем массив, чтобы порядок соответствовал списку типов
        this.item.patientAddresses = orderedAddresses;
      });
    },
    loadDiags() {
      this.firstTimeDiags =
        this.item.diagnosis?.filter((d) => d.diagType === 0) ?? [];
      this.updatedDiags =
        this.item.diagnosis?.filter((d) => d.diagType === 1) ?? [];
    },
    fileUploaded(e) {
      let entity = this.item.patientFiles[e.entityIndex];
      entity[e.propName + "Id"] = e.data.id;
      entity[e.propName] = e.data;
    },
    addFile() {
      var pf = { patientId: this.id, fileId: 0 };
      this.item.patientFiles = [...this.item.patientFiles, pf];
    },
    removeFile(idx) {
      this.item.patientFiles.splice(idx, 1);
    },
    copyAddress(address, type) {
      const sourceAddr = this.item.patientAddresses.find(
        (x) => x.addressType.name === "Residence"
      );
      const targetAddr = this.item.patientAddresses.find(
        (x) => x.addressType.name === type//"PermanentRegistration"
      );
      for (const [key, value] of Object.entries(sourceAddr)) {
        if (key === "id" || key === "addressTypeId" || key === "addressType") {
          continue;
        }
        targetAddr[key] = value;
      }
      this.nn++;
    },
    showQrCode() {
      API.getQrCode(this.id).then((response) => {
        this.qrCode = "data:image/png;base64,".concat(
          this.qrCode.concat(response.data)
        );
      });
    },
    updateFromRMIS() {
      var params = {
        id: this.item.externalId,
        surname: this.item.surname,
        name: this.item.name,
        middle: this.item.patronimic,
        dt: this.$momentFormat(this.item.dateOfBirth, "YYYY-MM-DD"),
        ourId: this.id,
      };
      API.importPersonRMIS(params).then((response) => {
        console.log(response.data);
        if (response.data.success) {
          Constants.alert.fire("Импорт", "Данные успешно обновлены", "success");
          this.loadPage();
        } else {
          Constants.alert.fire("Импорт", response.data.message, "error");
        }
      });
    },
    importDiagnosis() {
      this.importInProgress = true;
      API.updatePersonDiag(this.id).then((response) => {
        console.log(response.data);
        if (response.data.success) {
          if (response.data.newDiagCount)
            Constants.alert.fire(
              "Импорт",
              "Данные о диагнозах успешно обновлены.",
              "success"
            );
          else
            Constants.alert.fire(
              "Импорт",
              "Новые данные о диагнозах в ЕЦП не найдены.",
              "warning"
            );
          this.importInProgress = false;
          this.loadPage();
        } else {
          this.importInProgress = false;
          if (
            response.data.message ===
            "Отсутствует обязательный параметр 'Person_id'"
          ) {
            Constants.alert.fire(
              "Импорт",
              'Обновите данные из ЕЦП на вкладке "Общая информация"',
              "error"
            );
            return;
          }
          Constants.alert.fire("Импорт", response.data.message, "error");
        }
      });
    },
    save() {
      this.item.patientFiles = this.item.patientFiles.filter((x) => x.fileId);

      this.generalInvalid = false;
      this.representativesInvalid = false;
      this.diagInvalid = false;
      this.addressesInvalid = false;

      this.v$.$touch();
      const hasDuplicateSnils = this.hasDuplicateRepresentativeSnils();
      if (this.v$.$invalid || hasDuplicateSnils) {
        this.v$.$errors.forEach((e) => {
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "general"
          ) {
            this.generalInvalid = true;
          }
          if (
            (e.$response.extraParams &&
            e.$response.extraParams.scope === "representatives")
            || (this.v$.item.patientRepresentatives.$error)
          ) {
            this.representativesInvalid = true;
          }
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "diag"
          ) {
            this.diagInvalid = true;
          }
          if (
            e.$response.extraParams &&
            e.$response.extraParams.scope === "addresses"
          ) {
            this.addressesInvalid = true;
          }
        });

        if (hasDuplicateSnils) {
          this.representativesInvalid = true;
        }

        Constants.alert.fire(
          "Ошибка",
          "Проверьте правильность заполнения полей",
          "error"
        );
        return;
      }

      var toSave = Object.assign({}, this.item);
      if (toSave.insuranceTypeId == 0) {
        toSave.insuranceTypeId = null;
        toSave.insuranceSerie = "";
        toSave.insuranceNum = "";
      }

      // если PatientRepresentatives есть и это массив
      if (Array.isArray(toSave.patientRepresentatives)) {
        toSave.patientRepresentatives.forEach(pr => {
          if (pr?.representative) {
            delete pr.representative.user;
          }
        });
      }

      API.save(toSave).then((response) => {
        Constants.alert.fire(
          "Сохранение",
          response.data.message,
          response.data.success ? "success" : "error"
        );
        if (response.data.success) this.$router.push({ name: "Patients", query: { page: this.$route.query.page } });
      });
    },
    close() {
      this.$router.push({ name: "Patients", query: { page: this.$route.query.page } });
    },
    countryChanged() {
      if(this.item.countryId == Constants.countryRussiaId) {
        this.item.birthCertNum = "";
        this.item.passportSerie = "";
        this.item.passportNum = "";
      } else {
        if(this.item.birthCertNum)
          this.item.birthCertNum = this.item.birthCertNum.replace(/_/g, "");
         if(this.item.passportSerie)
          this.item.passportSerie = this.item.passportSerie.replace(/_/g, "");
        if(this.item.passportNum)
          this.item.passportNum = this.item.passportNum.replace(/_/g, "");
      }
    },
    getTitle(repres) {
      if(repres.representative.surname && repres.representative.surname.length > 0)
      {
        var res = repres.representative.surname;
        if(repres.representative.name && repres.representative.name.length > 0)
          res += " " + repres.representative.name;
        if(repres.representative.patronimic && repres.representative.patronimic.length > 0)
          res += " " + repres.representative.patronimic;
        if(repres.relationTypeId)
          res += " (" + this.relationTypeList.find(x => x.id == repres.relationTypeId)?.text + ")";

        return res;
      }

      return "Представитель";
    },
    isBirthDateObligatory(repres) {
      return repres.representative.dateObligatory;
    },
    editComment() {
      this.dopInfo.comment = this.item.comment;
      this.dopInfo.showCommentModal = true;
    },
    updateComment() {
      API.updateComment(this.item.id, this.dopInfo.comment).then((response) => {
        if(response.data.success) {
          this.item.comment = this.dopInfo.comment;
          this.dopInfo.showCommentModal = false;
        } else {
          Constants.alert.fire(
            "Сохранение",
            response.data.message ?? "Произошла ошибка",
            "error"
          );
        }
        
      });
    },
    hasDuplicateSnils(rIdx) {
      const normalize = s => (s || '').replace(/\D/g, '');

      const current = normalize(this.item.patientRepresentatives[rIdx].representative.snils);
      if (!current) return false;

      // Если совпадает со СНИЛС ребенка — считаем ребенка первым,
      // поэтому представитель подсвечивается
      if (current === normalize(this.item.snils)) {
        return true;
      }

      // Проверяем только предыдущих представителей
      for (let i = 0; i < rIdx; i++) {
        const snils = normalize(this.item.patientRepresentatives[i].representative.snils);
        if (snils === current) {
          return true;
        }
      }

      return false;
    },
    hasDuplicateRepresentativeSnils() {
      const normalize = s => (s || '').replace(/\D/g, '');

      const childSnils = normalize(this.item.snils);
      const map = {};

      for (const repres of this.item.patientRepresentatives) {
        const snils = normalize(repres.representative.snils);
        if (!snils) continue;

        // Совпадение с ребенком
        if (snils === childSnils) {
          return true;
        }

        map[snils] = (map[snils] || 0) + 1;
        if (map[snils] > 1) {
          return true;
        }
      }

      return false;
    }
  },
  computed: {
    fullName() {
      var patronimic = this.item.patronimic != null ? this.item.patronimic : "";
      return `${this.item.surname} ${this.item.name} ${patronimic}`;
    },
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      item: {
        //snils: {required, snilsValidator},
        //dateOfBirth: {required},
        //birthCertNum: { numberFixLengthValidator: numberFixLengthValidator(6) },
        //passportDep: {passportDepValidator},
        //passportWhere: {maxLength: maxLength(200)},
        //passportSerie: {numberFixLengthValidator: numberFixLengthValidator(4)},
        //passportNum: {numberFixLengthValidator: numberFixLengthValidator(6)},
        //insuranceTypeId: {required, selectValidator},
        male: { required },
        insuranceSerie: {
          required: requiredIf(function () {
            return this.item.insuranceTypeId == 4;
          }),
          numberFixLengthValidator: numberFixLengthValidator(
            5,
            this.item.insuranceTypeId
          ),
        },
        insuranceNum: {
          insNumLengthValidator: insNumLengthValidator(
            this.item.insuranceTypeId
          ),
        },
        seniority: { numeric },
        agreePersonalData: { sameAs: (val) => val === true },
        patientRepresentatives: { required }
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import "/src/modules/ras/views/index";
.nav-tabs {
  margin: 16px 36px 0 36px;
  justify-content: center;
  border: none;

  .nav-item {
    margin-top: 12px;
    max-width: 240px;
    width: 100%;
    margin-right: 8px;
    margin-left: 8px;

    .nav-link {
      padding: 14.5px 5px;
      text-align: center;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      min-width: 160px;
      font-size: 16px;
      line-height: 110%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.disabled {
        opacity: 0.5;
      }

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}
h2 {
  margin-top: 21px;
}

h4 {
  font-size: 16px;
  font-weight: 600;
}

.img-qr-code {
  width: 140px;
  height: auto;
}

.solid {
  background-color: #f5f5fa; //rgba(171,171,179, 0.1);
  line-height: 3rem;
  letter-spacing: 0.5px;
}

.white {
  background-color: white;
}
</style>
<style lang="scss">
.select2-container {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
  display: block;
  margin: 0;
  position: relative;
  vertical-align: middle;
}

.select2-container--default .select2-selection--single {
  height: calc(2.25rem + 2px) !important;
}

.select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  top: 7px !important;
}

textarea.textareaBig {
  height: 180px !important;
}
// html:has(.personal-address) {
//   overflow: hidden;
// }
</style>
